import React from 'react'
import { UserDropdown } from './userDropdown'
import { useParams } from 'react-router-dom'
import { HamburgerMenu } from './HamburgerMenu'

export function Topbar({ isOnboarding = false }) {
  const { selectedMenu } = useParams()

  return (
    <div className="h-full flex items-center px-3 md:px-6 gap-2">
      {/* Hamburger menu for mobile */}
      <div className="md:hidden">
        <HamburgerMenu selectedMenu={selectedMenu || 'home'} isOnboarding={isOnboarding} />
      </div>

      {/* User dropdown - simplified on mobile */}
      <div className="flex-shrink-0 ml-auto">
        <UserDropdown />
      </div>
    </div>
  )
}
